import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/lib/Seo";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : "/api";

export default function NewsDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(undefined);

  useEffect(() => {
    fetch(`${API}/news/by-slug/${encodeURIComponent(slug)}`)
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then(setItem)
      .catch(() => setItem(null));
  }, [slug]);

  if (item === undefined) return <div className="min-h-screen bg-paper pt-32 text-center text-blue">جارٍ تحميل الخبر…</div>;
  if (item === null) return <Navigate to="/news" replace />;

  return <>
    <Seo path={`/news/${item.slug}`} title={item.title} description={item.meta_description || item.excerpt} type="article" />
    <article>
      <header className="bg-navy text-white pt-32 pb-16">
        <div className="mx-auto max-w-4xl px-6 sm:px-10">
          <Link to="/news" className="inline-flex items-center gap-2 text-peach"><ArrowRight size={17}/> أخبارنا</Link>
          <h1 className="font-display text-3xl sm:text-5xl leading-tight mt-7">{item.title}</h1>
          {item.published_at && <time className="block text-white/65 mt-5">{new Date(item.published_at).toLocaleDateString("ar-SA")}</time>}
        </div>
      </header>
      <div className="bg-paper py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-6 sm:px-10">
          {item.cover_image && <img src={item.cover_image} alt="" className="w-full mb-10" />}
          <p className="text-blue text-lg leading-[2] whitespace-pre-line">{item.body || item.excerpt}</p>
        </div>
      </div>
    </article>
  </>;
}
